export default "__VITE_ASSET__0f9ce867__"